import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentHistory = createSelector(
  [(store: RootState) => store.documentSupervisorShow.history],
  (data = []) => data
);
